import React from 'react';
import {formatPhoneNumber, formatNumber, formatDate, formatAgentPercent, percent,formatDateTime,viewDateTimeFormat} from "../../utils";
import PropTypes from "prop-types";

require('./Input.scss');

const Input = ({theme = 'default', id, value, inputType, valueType = 'text', label, handleParentChange, handleParentBlur, decimals = 0, style, viewMode = false, deleted = false, className = "", isDollar = false, withCommas = false, tooltip, tooltipPosition='up', handleInputFocus, onInputClick, onKeyUp, ...rest}) => {
    const formatValue = (value, type) => {
        switch (type) {
            case 'number':
            case 'float':   // with commas and decimals
                return formatNumber(value, isDollar || withCommas);
            case 'integer': // with commas
            case 'years':
            case 'percent':
                return formatNumber(value, isDollar || withCommas);
            case 'phone':
                return formatPhoneNumber(value);
            case 'date':
                return formatDate(value);
            case 'datetime':
                return formatDateTime(value);                
            case 'agent-percent':
                return formatAgentPercent(value);
            default:
                return value;
        }
    };

    const formatViewValue = () => {
        if (!value) return '-';
        switch (valueType) {
            case 'number':
                return formatNumber(value);
            case 'integer':
                return `${isDollar ? '$' : ''}${formatNumber(value, isDollar || withCommas)}`;
            case 'float':
                return `${isDollar ? '$' : ''}${formatNumber(value, isDollar || withCommas, decimals)}`;
            case 'phone':
                return formatPhoneNumber(value);
            case 'date':
                return formatDate(value);
            case 'datetime':
                return viewDateTimeFormat(value); 
            case 'percent':
            case 'agent-percent':
                return percent(value, decimals);
            case 'years':
                return `${value} Years`;
            default:
                return value;
        }
    };
    
    const handleChange = (e) => {
        const key = e.currentTarget.name;
        const value = formatValue(e.currentTarget.value, valueType);
        handleParentChange(key, value);
        return value;
    };

    const handleBlur = (e) => {
        const key = e.currentTarget.name;
        const value = formatValue(e.currentTarget.value, valueType);
        handleParentBlur(key, value);
        return value;
    };

    if (!decimals)
        decimals = valueType === 'percent' ? 2 : 0;
    const disabled = rest.disabled;
    const isPercent = valueType === 'percent';
    const agentPercent = valueType === 'agent-percent';
    const val = formatValue(value, valueType);
    const viewVal = formatViewValue();
    if (valueType === 'email') rest.type = 'email';

    return (
        <div id={id} className={`input-container ${theme}${agentPercent ? ' agent-percent' : ''} ${className}`}>
            {
                label &&
                <label className={`input-label ${theme}${disabled ? ' disabled' : ''}`}>{label}</label>
            }

            {
                viewMode && tooltip &&
                <span className={`tooltip-new ${tooltipPosition ? tooltipPosition:''}`}>{tooltip}</span>
            }

            {
                !viewMode &&
                <div className={`input-wrapper  ${onInputClick ? 'clickable' : ''} ${inputType!=='textarea' ? " " : "text-wrapper"}`} onClick={onInputClick}>
                    {
                        inputType!=='textarea' ?
                        <input className={`input ${theme}${disabled ? ' disabled' : ''}${isPercent ? ' percent' : ''}${agentPercent ? ' agent-percent' : ''}`}
                           style={style}
                           value={val || ''}
                           onChange={handleChange}
                           onBlur = {handleParentBlur ? handleBlur : null}
                           onFocus={handleInputFocus}
                           onKeyUp={onKeyUp}
                           {...rest}
                    />
                    :   <textarea className={`input ${theme}${disabled ? ' disabled' : ''}${isPercent ? ' percent' : ''}${agentPercent ? ' agent-percent' : ''}`}
                    style={style}
                    value={val || ''}
                    rows={5}
                    onChange={handleChange}
                    onBlur = {handleParentBlur ? handleBlur : null}
                    onFocus={handleInputFocus}
                    onKeyUp={onKeyUp}
                    {...rest}
             /> }
                    {
                        (isPercent || agentPercent) &&
                        <React.Fragment>
                            {
                                agentPercent &&
                                <span className={`percentage${!value ? ' no-value' : ''}`}>%</span>
                            }
                            <div className={`input-display-value ${theme}${disabled ? ' disabled' : ''}${isPercent ? ' percent' : ''}${agentPercent ? ' agent-percent' : ''}${!value ? ' no-value' : ''}`}>
                                {value ? Number(value).toFixed(decimals) : ''}
                            </div>
                        </React.Fragment>
                    }
                </div>
            }
            {
                viewMode &&
                <div className={`view ${theme}${disabled ? ' disabled': ''}${deleted ? ' input-view-mode-deleted' : ''} ${onInputClick ? 'clickable' : ''}`} onClick={onInputClick}>
                    {viewVal} 
                </div>
            }
        </div>
    )
};

Input.propTypes = {
    theme: PropTypes.oneOf([
        'default',
        'white',
        'dark',
        'without-border'
    ]),
    id: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]),
    valueType: PropTypes.oneOf([
        'text',
        'number',
        'integer',
        'float',
        'phone',
        'email',
        'date',
        'percent',
        'agent-percent',
        'years'
    ]),
    label: PropTypes.string,
    handleParentChange: PropTypes.func,
    handleParentBlur: PropTypes.func,
    decimals: PropTypes.number,
    style: PropTypes.object,
    viewMode: PropTypes.bool,
    disabled: PropTypes.bool,
    deleted: PropTypes.bool,
    className: PropTypes.string,
    isDollar: PropTypes.bool,
    withCommas: PropTypes.bool,
    tooltip: PropTypes.string,  
    tooltipPosition: PropTypes.oneOf(['up','down']),
    handleInputFocus: PropTypes.func,
    onInputClick: PropTypes.func
};

export default Input;